import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=d87fda50&scoped=true&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87fda50",
  null
  
)

export default component.exports